import React from "react";
import * as Mui from "@mui/material";
import { makeStyles } from "tss-react/mui";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import { Office } from "model/office";

const useStyles = makeStyles()((theme) => ({
	row: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(1),
		padding: "12px 16px",
		backgroundColor: theme.palette.background.paper,
	},
	handle: {
		display: "flex",
		alignItems: "center",
		color: theme.palette.custom?.textTertiary || "rgba(0,0,0,0.38)",
		cursor: "grab",
	},
	name: {
		flex: 1,
		minWidth: 0,
		fontSize: 16,
		lineHeight: "24px",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap",
	},
	// Read-only position tag per the Figma — unlike the agent card, which offers a numeric
	// stepper. Offices reorder by dragging only.
	positionTag: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		minWidth: 28,
		height: 28,
		padding: "0 6px",
		borderRadius: 4,
		backgroundColor: theme.palette.action.hover,
		color: theme.palette.text.secondary,
		fontSize: 14,
		lineHeight: "20px",
	},
}));

interface Props {
	office: Office;
	position: number;
	isLast?: boolean;
}

/** One draggable row in the Offices custom display order list (MAX-4065). */
export const OfficeCard: React.FC<Props> = ({ office, position, isLast }) => {
	const { classes } = useStyles();
	return (
		<Mui.Box
			className={classes.row}
			style={{ borderBottom: isLast ? "none" : "1px solid rgba(0,0,0,0.12)" }}
		>
			<span className={classes.handle}>
				<DragIndicatorIcon fontSize="small" />
			</span>
			<Mui.Typography className={classes.name}>{office.name}</Mui.Typography>
			<span className={classes.positionTag}>{position}</span>
		</Mui.Box>
	);
};
